import ViewListOutlinedIcon from '@material-ui/icons/ViewListOutlined';
import EstadoReglaShow from './EstadoReglaShow';
import EstadoReglaList from './EstadoReglaList';

const indexEstadoRegla = {
    icon: ViewListOutlinedIcon,
    list: EstadoReglaList,
    show: EstadoReglaShow,
};

export default indexEstadoRegla;
